<div class="d-flex flex-column justify-content-between align-items-center" style="gap: 500px">
  <p></p>
  <div class="d-flex justify-content-center align-items-center" style="gap: 30px">
    <img src="assets/images/odq-logo-Icon-small.png">
    <div [innerHTML]="'maintenance' | translate"></div>
  </div>
</div>


